import React, { useState } from "react";
import { Box, Typography, Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { useForm } from "react-hook-form";
import ActionButton from "../Common/Components/Button";
import { useTranslation } from "react-i18next";
import VerifyOtpPage from "../Common/Components/VerifyOtp";
import Input from "../Common/Components/InputField";
import BubbleImg from "../assets/bubbles.svg";
import ForgotSuccessImg from "../assets/ForgotSuccess.svg";
import {
  forgotPassword,
  getOtp,
  getNewPassWord,
  reSendOTP,
} from "../apiSection/apiUrlConstent";
import Loading from "../Common/Components/Loading";
import { ShowAlert } from "../Common/Components/Alert";
import service from "../apiSection/service";

export default function ForgotPasswordScreen(props) {
 
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const { t } = useTranslation("common");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm();
  const hanldeshowPassword = (data) => {
    setShowPassword(data);
  };
  const handleLogin = (data) => {
    handleForgotPassword(data);
  };
  let countryList = [{ id: 1, dispalyValue: "+91" }];
  setValue("cCode", 1);
  const handleMobileValidation = (e) => {
    const newValue = e.target.value.replace(/[^0-9()+]/g, "");
    setValue("receiverMobileNumber", newValue);
  };
  const handleVerifyOtp = (data) => {
    if (data.length === 6) {
      setLoading(true);
      const postData = {
        otp: data,
        user_id: userId,
      };
      service
        .create(getOtp, postData)
        .then((res) => {
          setLoading(false);
          if (res.status === 200) {
            ShowAlert({
              icon: "success",
              text: res.data.message,
              width: "400px",
            });
            setStep(3);
          }
        })
        .catch((error) => {
          setLoading(false);
         
          ShowAlert({
            icon: "error",
            text: error?.response?.data?.message || "Something went wrong",
            width: "400px",
          });
        });
    }
  };

  const handlePasswordIcon = (event) => {
    setShowPassword(event);
  };
  const handlePasswordIconNew = (event) => {
    setShowConfirmPassword(event);
  };
  const handleChangePassword = (data) => {
    setLoading(true);
    const postData = {
      password: data.newpassword,
      confirm_password: data.conformPassword,
      user_id: userId,
    };
    service
      .create(getNewPassWord, postData)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          ShowAlert({
            icon: "success",
            text: res.data.message,
            width: "400px",
          });
          setStep(4);
        }
      })
      .catch((error) => {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: error?.response?.data?.message || "Something went wrong",
          width: "400px",
        });
      });
  };
  const handlereDirectLogin = () => {
    props.Redirectpath("/");
  };

  const handleForgotPassword = (data) => {
    setLoading(true);
    const postData = {
      user_details: data.receiveremailaddress,
    };

    service
      .create(forgotPassword, postData)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setStep(2);
          ShowAlert({
            icon: "success",
            // text: res.data.message,
            text:"OTP Sent Successfully",
            width: "400px",
          });
        }
        setUserId(res.data.result.user_id);
      })
      .catch((error) => {
        setLoading(false);
       
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          ShowAlert({
            icon: "error",
            text: error?.response?.data?.message || "Something went wrong",
            width: "400px",
          });
        } else {
          ShowAlert({
            icon: "error",
            text: "Something went wrong!",
            width: "400px",
          });
        }
      });
  };
  const handleResendOtp = () => {
    let postObj = {
      user_id: userId,
    };

    service
      .create(reSendOTP, postObj)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          ShowAlert({
            icon: "success",
            text: res.data.message,
            width: "400px",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: error?.response?.data?.message || "Something went wrong",
          width: "400px",
        });
      });
  };
  return (
    <Grid container sx={{ height: "100vh" }}>
      {/* Left Section */}
      <Loading open={loading} />
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          background: "linear-gradient(180deg, #FFFFFF 0%, #0FA5D9 100%);",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
        }}
      >
        <Box textAlign="center">
          <div>
            <img src={BubbleImg} width="100%" />
          </div>
          <Typography
            color="#FFFFFF"
            sx={{
              fontStyle: "italic",
              fontFamily: "Poppins",
              fontSize: "40px",
            }}
          >
            AI-POWERED
          </Typography>
          <Typography
            color="#000080"
            sx={{
              mt: 2,
              fontStyle: "italic",
              fontFamily: "Poppins",
              fontSize: "36px",
            }}
          >
            Help Desk
          </Typography>
        </Box>
      </Grid>

      {/* Right Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
          bgcolor: "#fff",
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 400 }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "#3399FF" }}
          >
            Ticketing Tool
          </Typography>
          {step != 4 && (
            <Typography color="#2B3674" sx={{ mt: 1 }}>
              Forgot Password
            </Typography>
          )}

          <Box component="form" noValidate sx={{ mt: 4 }}>
            {step == 1 && (
              <div>
                <Typography color="#4B5563" sx={{ my: 2 }}>
                  Please provide the email address linked to your account
                </Typography>
                <Input
                  name="receiveremailaddress"
                  type="text"
                  id="receiveremailaddress"
                  label={t("forgotEmail")}
                  borderRadius="8px"
                  backgroundColor="white"
                  color="#707EAE"
                  placeholder={t("forgotEmail")}
                  required={true}
                  inputRef={register("receiveremailaddress", {
                    required: true,
                    pattern: {
                      value:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: t("invalidEmail"),
                    },
                  })}
                />

                <div>
                  {errors.receiveremailaddress &&
                    errors.receiveremailaddress.type === "required" && (
                      <ErrorMessage message={t("emailRequired")} />
                    )}
                  {errors.receiveremailaddress && (
                    <ErrorMessage
                      message={errors.receiveremailaddress.message}
                    />
                  )}
                </div>

                <div style={{ padding: "15px 0px" }}>
                  <ActionButton
                    backgroundColor="#3399FF"
                    color="white"
                    fullWidth={true}
                    buttonText="Continue"
                    handleSubmit={handleSubmit(handleLogin)}
                  />
                </div>
              </div>
            )}
            {step == 2 && (
              <div>
                <Typography color="#4B5563" sx={{ mt: 1 }}>
                  An OTP (One-Time Password) has been sent to your registered
                  Email Address . Please enter the OTP below.
                </Typography>

                <VerifyOtpPage
                  handleVerifyOtp={handleVerifyOtp}
                  handleResendOtp={handleResendOtp}
                  userId={userId}
                  //   resultData={resultData}
                />
              </div>
            )}
            {step == 3 && (
              <div>
                <div style={{ padding: "10px 0px" }}>
                  <Input
                    name="newpassword"
                    type={showPassword ? "text" : "password"}
                    id="newpassword"
                    label="New Password"
                    borderRadius="8px"
                    border="none"
                    backgroundColor="white"
                    maxLength={16}
                    color="#707EAE"
                    visibilityIcon
                    visibilityIconColor="#0FA5D8"
                    placeholder="New Password"
                    required={true}
                    hanldeshowPassword={handlePasswordIcon}
                    inputRef={register("newpassword", {
                      required: "New Password is Required",
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z\d!@#$%^&*]{8,16}$/gm,
                    })}
                  />

                  <div>
                    {errors.newpassword &&
                      errors.newpassword.type === "required" && (
                        <ErrorMessage message="Required !!" />
                      )}
                    {errors.newpassword &&
                      errors.newpassword.type === "pattern" && (
                        <ErrorMessage message="Password must be 8-16 characters long and include at least one uppercase letter, one lowercase letter, and one special character." />
                      )}
                  </div>
                </div>
                <div style={{ padding: "10px 0px" }}>
                  <Input
                    name="conformPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    id="conformPassword"
                    label="Confirm New Password"
                    borderRadius="8px"
                    maxLength={15}
                    minLength={10}
                    visibilityIcon
                    border="none"
                    backgroundColor="white"
                    color="#707EAE"
                    required={true}
                    visibilityIconColor="#0FA5D8"
                    hanldeshowPassword={handlePasswordIconNew}
                    placeholder="Confirm New Password"
                    inputRef={register("conformPassword", {
                      required: "Required !!!",

                      validate: (value) =>
                        value === watch("newpassword") ||
                        "Password do not match",
                    })}
                  />

                  {errors.conformPassword && (
                    <ErrorMessage message={errors.conformPassword.message} />
                  )}
                </div>
                <div>
                  <ActionButton
                    backgroundColor="rgb(15, 165, 217)"
                    color="white"
                    buttonText="Change Password"
                    handleSubmit={handleSubmit(handleChangePassword)}
                  />
                </div>
              </div>
            )}
            {step == 4 && (
              <div style={{ textAlign: "center" }}>
                <div>
                  <img src={ForgotSuccessImg} width="60%" />
                </div>
                <Typography sx={{ color: "#2B3674", fontSize: "18px" }}>
                  Your Password has been Reset
                </Typography>
                <Typography color="#139A38" sx={{ mt: 1, fontSize: "35px" }}>
                  Successfully
                </Typography>
                <div>
                  <ActionButton
                    backgroundColor="rgb(15, 165, 217)"
                    color="white"
                    buttonText="Login"
                    handleSubmit={handlereDirectLogin}
                  />
                </div>
              </div>
            )}
          </Box>

          <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            sx={{ mt: 4 }}
          >
            ©2024 Powered by Machint Solutions Ltd
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}
